export enum LogLevel {
  silent = 0,
  info = 1,
  warning = 2,
  fatal = 3,
  verbose = 4,
}
